import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  ResponseSuccess,
  ResponseErrorWithHandled,
} from '../../../../shared/types';

import {
  getAdminSettings,
  updateAdminSettings,
} from '../../helpers/admin-settings.api';
import { UpdateAdminSettingsRequestPayload } from '../../types/request-payload';
export const getAdminSettingsRequest = createAsyncThunk<
  ResponseSuccess,
  null,
  { rejectValue: ResponseErrorWithHandled }
>('adminSettings/getAdminSettingsRequest', async (args, thunkAPI) => {
  try {
    return await getAdminSettings();
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const updateAdminSettingsRequest = createAsyncThunk<
  ResponseSuccess,
  UpdateAdminSettingsRequestPayload,
  { rejectValue: ResponseErrorWithHandled }
>('adminSettings/updateAdminSettingsRequest', async (args, thunkAPI) => {
  try {
    return await updateAdminSettings(args);
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});
